// extracted by mini-css-extract-plugin
export default {"video-wrapper":"_1Uxvs","videoWrapper":"_1Uxvs","preset-comment":"_2yDVB","presetComment":"_2yDVB","small-media":"_2GkxU","smallMedia":"_2GkxU","left":"_1HOyi","right":"_18rk3"};